import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface CategorySummary {
  guests: number;
  nights: number;
  tax: number;
}

export interface ReservationTaxLine {
  reservationId: number;
  guestName: string;
  checkIn: string;
  checkOut: string;
  nights: number;
  adultCount: number;
  childCount: number;
  disabledCount: number;
  tax: number;
  /** Complete guests of this stay the chosen basis left out of the counts (#206). Absent on an older backend. */
  excludedCount?: number;
}

/**
 * Which complete guests the report counts. COMPLETED_GUESTS is the report as it always was;
 * UBYPORT_FILED counts Czech guests plus foreign guests filed to Ubyport. Chosen per request, never stored.
 */
export type CityTaxBasis = 'COMPLETED_GUESTS' | 'UBYPORT_FILED';
export const DEFAULT_CITY_TAX_BASIS: CityTaxBasis = 'COMPLETED_GUESTS';

export interface CityTaxReport {
  dateFrom: string;
  dateTo: string;
  adultRate: number;
  childRate: number;
  disabledRate: number;
  totalTax: number;
  totalReservations: number;
  adults: CategorySummary;
  children: CategorySummary;
  disabled: CategorySummary;
  reservations: ReservationTaxLine[];
  payerName?: string;
  payerCompanyName?: string;
  payerIco?: string;
  payerAddress?: string;
  payerPhone?: string;
  payerEmail?: string;
  bankAccount?: string;
  variableSymbol?: string;
  apartmentAddress?: string;
  apartmentName?: string;
  mailboxName?: string;
  mailboxDataboxId?: string;
  mailboxAddress?: string;
  /** The basis the backend applied; absent on an older backend, which only knows COMPLETED_GUESTS. */
  basis?: CityTaxBasis;
  /** Complete guests left out by the basis (0 for COMPLETED_GUESTS). */
  excludedGuests?: number;
}

export const getCityTaxReport = async (
  apartmentId: number,
  dateFrom: string,
  dateTo: string,
  token: string,
  basis: CityTaxBasis = DEFAULT_CITY_TAX_BASIS
): Promise<CityTaxReport> => {
  const res = await axios.get(`${API_BASE}/apartments/${apartmentId}/city-tax/report`, {
    // The default is left off the wire so the request stays exactly what it was before the toggle existed.
    params: basis === DEFAULT_CITY_TAX_BASIS ? { dateFrom, dateTo } : { dateFrom, dateTo, basis },
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};
